import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { CellarDoorSection } from './components/CellarDoorSection';
import { RestaurantSection } from './components/RestaurantSection';
import { WineClubSection } from './components/WineClubSection';
import { WeddingsSection } from './components/WeddingsSection';
import { PartnersSection } from './components/PartnersSection';
import { NewsletterSection } from './components/NewsletterSection';
import { Footer } from './components/Footer';
import { Testimonials } from './components/Testimonials';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header variant="light" data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <CellarDoorSection data-id="element-4" />
        <RestaurantSection data-id="element-5" />
        <Testimonials data-id="element-6" />
        <WeddingsSection data-id="element-7" />
        <WineClubSection data-id="element-8" />
        <PartnersSection data-id="element-9" />
        <NewsletterSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}